import * as Types from '../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { FlowStateUpdateFragmentFragmentDoc } from '../../_components/flow/generated';
import { SignInFlowFragmentFragmentDoc } from '../generated';
export type LoginWithAppleForProgramFlowMutationVariables = Types.Exact<{
  appleToken: Types.Scalars['String']['input'];
  nameFirst?: Types.InputMaybe<Types.Scalars['String']['input']>;
  nameLast?: Types.InputMaybe<Types.Scalars['String']['input']>;
  affiliateSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  affiliateExternalId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  affiliateFirstEncounteredAt?: Types.InputMaybe<Types.Scalars['String']['input']>;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type LoginWithAppleForProgramFlowMutation = { __typename?: 'Mutation', loginWithApple: { __typename?: 'User', id: string, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string }, customer: { __typename?: 'Customer', id: string, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null } };

export type CreateUserAndEnrollmentForAppleAuthMutationVariables = Types.Exact<{
  data: Types.CustomerAndEnrollmentItemCreateInput;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type CreateUserAndEnrollmentForAppleAuthMutation = { __typename?: 'Mutation', createOneCustomer: { __typename?: 'CustomerAndEnrollmentItem', customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, nameFirst: string | null, nameLast: string | null, phone: string | null, email: string | null, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } | null, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } } | null };

export type UpdateCustomerForAppleAuthMutationVariables = Types.Exact<{
  data: Types.CustomerUpdateInput;
  shouldGetTokens: Types.Scalars['Boolean']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerForAppleAuthMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, acceptedDreamboundTerms: boolean | null }, user: { __typename?: 'User', id: string, nameFirst: string | null, nameLast: string | null, email: string | null, phone: string | null, tokens?: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } | null, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type LoginWithAppleForSignInMutationVariables = Types.Exact<{
  appleToken: Types.Scalars['String']['input'];
  affiliateSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  affiliateExternalId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  affiliateFirstEncounteredAt?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LoginWithAppleForSignInMutation = { __typename?: 'Mutation', loginWithApple: { __typename?: 'User', id: string, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string }, customer: { __typename?: 'Customer', id: string, signInFlow: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null } };

export type LoginWithGoogleForGoogleAuthMutationVariables = Types.Exact<{
  googleToken: Types.Scalars['String']['input'];
  affiliateSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  affiliateExternalId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  affiliateFirstEncounteredAt?: Types.InputMaybe<Types.Scalars['String']['input']>;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type LoginWithGoogleForGoogleAuthMutation = { __typename?: 'Mutation', loginWithGoogle: { __typename?: 'User', id: string, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string }, customer: { __typename?: 'Customer', id: string, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null } };

export type CreateUserAndEnrollmentForGoogleAuthMutationVariables = Types.Exact<{
  data: Types.CustomerAndEnrollmentItemCreateInput;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type CreateUserAndEnrollmentForGoogleAuthMutation = { __typename?: 'Mutation', createOneCustomer: { __typename?: 'CustomerAndEnrollmentItem', customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, nameFirst: string | null, nameLast: string | null, phone: string | null, email: string | null, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } | null, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } } | null };

export type UpdateCustomerForGoogleAuthMutationVariables = Types.Exact<{
  data: Types.CustomerUpdateInput;
  shouldGetTokens: Types.Scalars['Boolean']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerForGoogleAuthMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, acceptedDreamboundTerms: boolean | null }, user: { __typename?: 'User', id: string, nameFirst: string | null, nameLast: string | null, email: string | null, phone: string | null, tokens?: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } | null, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type LoginWithGoogleMutationVariables = Types.Exact<{
  googleToken: Types.Scalars['String']['input'];
  affiliateSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  affiliateExternalId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  affiliateFirstEncounteredAt?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LoginWithGoogleMutation = { __typename?: 'Mutation', loginWithGoogle: { __typename?: 'User', id: string, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string }, customer: { __typename?: 'Customer', id: string, signInFlow: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null } };


export const LoginWithAppleForProgramFlowDocument = gql`
    mutation loginWithAppleForProgramFlow($appleToken: String!, $nameFirst: String, $nameLast: String, $affiliateSlug: String, $affiliateExternalId: String, $affiliateFirstEncounteredAt: String, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  loginWithApple(
    appleToken: $appleToken
    nameFirst: $nameFirst
    nameLast: $nameLast
    affiliateSlug: $affiliateSlug
    affiliateExternalId: $affiliateExternalId
    affiliateFirstEncounteredAt: $affiliateFirstEncounteredAt
  ) {
    id
    tokens {
      accessToken
      refreshToken
    }
    customer {
      id
      ...FlowStateUpdateFragment
    }
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<LoginWithAppleForProgramFlowMutation, LoginWithAppleForProgramFlowMutationVariables>;
export const CreateUserAndEnrollmentForAppleAuthDocument = gql`
    mutation createUserAndEnrollmentForAppleAuth($data: CustomerAndEnrollmentItemCreateInput!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  createOneCustomer(data: $data) {
    customer {
      id
      user {
        id
        nameFirst
        nameLast
        phone
        email
        tokens {
          accessToken
          refreshToken
        }
      }
      ...FlowStateUpdateFragment
    }
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<CreateUserAndEnrollmentForAppleAuthMutation, CreateUserAndEnrollmentForAppleAuthMutationVariables>;
export const UpdateCustomerForAppleAuthDocument = gql`
    mutation updateCustomerForAppleAuth($data: CustomerUpdateInput!, $shouldGetTokens: Boolean!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomer(data: $data) {
    id
    detailsMap {
      id
      acceptedDreamboundTerms
    }
    user {
      id
      nameFirst
      nameLast
      email
      phone
      tokens @include(if: $shouldGetTokens) {
        accessToken
        refreshToken
      }
    }
    ...FlowStateUpdateFragment
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerForAppleAuthMutation, UpdateCustomerForAppleAuthMutationVariables>;
export const LoginWithAppleForSignInDocument = gql`
    mutation loginWithAppleForSignIn($appleToken: String!, $affiliateSlug: String, $affiliateExternalId: String, $affiliateFirstEncounteredAt: String) {
  loginWithApple(
    appleToken: $appleToken
    affiliateSlug: $affiliateSlug
    affiliateExternalId: $affiliateExternalId
    affiliateFirstEncounteredAt: $affiliateFirstEncounteredAt
  ) {
    id
    tokens {
      accessToken
      refreshToken
    }
    customer {
      id
      signInFlow {
        ...SignInFlowFragment
      }
    }
  }
}
    ${SignInFlowFragmentFragmentDoc}` as unknown as DocumentNode<LoginWithAppleForSignInMutation, LoginWithAppleForSignInMutationVariables>;
export const LoginWithGoogleForGoogleAuthDocument = gql`
    mutation loginWithGoogleForGoogleAuth($googleToken: String!, $affiliateSlug: String, $affiliateExternalId: String, $affiliateFirstEncounteredAt: String, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  loginWithGoogle(
    googleToken: $googleToken
    affiliateSlug: $affiliateSlug
    affiliateExternalId: $affiliateExternalId
    affiliateFirstEncounteredAt: $affiliateFirstEncounteredAt
  ) {
    id
    tokens {
      accessToken
      refreshToken
    }
    customer {
      id
      ...FlowStateUpdateFragment
    }
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<LoginWithGoogleForGoogleAuthMutation, LoginWithGoogleForGoogleAuthMutationVariables>;
export const CreateUserAndEnrollmentForGoogleAuthDocument = gql`
    mutation createUserAndEnrollmentForGoogleAuth($data: CustomerAndEnrollmentItemCreateInput!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  createOneCustomer(data: $data) {
    customer {
      id
      user {
        id
        nameFirst
        nameLast
        phone
        email
        tokens {
          accessToken
          refreshToken
        }
      }
      ...FlowStateUpdateFragment
    }
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<CreateUserAndEnrollmentForGoogleAuthMutation, CreateUserAndEnrollmentForGoogleAuthMutationVariables>;
export const UpdateCustomerForGoogleAuthDocument = gql`
    mutation updateCustomerForGoogleAuth($data: CustomerUpdateInput!, $shouldGetTokens: Boolean!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomer(data: $data) {
    id
    detailsMap {
      id
      acceptedDreamboundTerms
    }
    user {
      id
      nameFirst
      nameLast
      email
      phone
      tokens @include(if: $shouldGetTokens) {
        accessToken
        refreshToken
      }
    }
    ...FlowStateUpdateFragment
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerForGoogleAuthMutation, UpdateCustomerForGoogleAuthMutationVariables>;
export const LoginWithGoogleDocument = gql`
    mutation loginWithGoogle($googleToken: String!, $affiliateSlug: String, $affiliateExternalId: String, $affiliateFirstEncounteredAt: String) {
  loginWithGoogle(
    googleToken: $googleToken
    affiliateSlug: $affiliateSlug
    affiliateExternalId: $affiliateExternalId
    affiliateFirstEncounteredAt: $affiliateFirstEncounteredAt
  ) {
    id
    tokens {
      accessToken
      refreshToken
    }
    customer {
      id
      signInFlow {
        ...SignInFlowFragment
      }
    }
  }
}
    ${SignInFlowFragmentFragmentDoc}` as unknown as DocumentNode<LoginWithGoogleMutation, LoginWithGoogleMutationVariables>;